// Функция для генереции случайного выбора
export function getRandomBoolean(): boolean {
  return Boolean(Math.round(Math.random()));
}
